export const BACK_BUTTON = "volver";
export const ADD_BUTTON = "Cargar más";
export const ADD_PRE_BUTTON = "Anteriores";
